/* eslint-disable no-loop-func */
/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useState } from 'react';
import { TFunction } from 'i18next';
import { Box, Group, Radio, Stack } from '@mantine/core';

import { CreditOptionsResponse } from 'types';
import { DECIMAL_PROPS, InputLabel, NumberInput, SectionLabel, Select, Text } from 'components';
import { AppUtils } from 'utils';
import { AppConstants } from '../../../../../../constants';

const { CREDIT_REQUEST_FORM_PADDING } = AppConstants;

interface CreditRequestExpensesItemProps {
  disabled?: boolean;
  form: any;
  expenseForm: any;
  options: CreditOptionsResponse;
  t: TFunction;
  index: number;
  tempExpenseObject: object;
}

const CreditRequestExpensesItem = ({ disabled, expenseForm, form, index, options, t, tempExpenseObject }: CreditRequestExpensesItemProps) => {

  const [additionalExpense, setAdditionalExpense] = useState<boolean>(expenseForm.values[index + 1]);

  const changeAdditionalExpense = useCallback((val: boolean) => {
    setAdditionalExpense(val);
    if (val) {
      AppUtils.addNewObject(expenseForm, { ...tempExpenseObject, creditRequestId: form.values.id });
    } else {
      AppUtils.removeObject(expenseForm, index + 1, { ...tempExpenseObject, creditRequestId: form.values.id })
    }
  }, []);

  return (
    <Box key={`expense-${index}`} mt={'md'}>
      <SectionLabel label={t('credit.expense.label')} variant={'green'} mb={16} />
      <Stack pb={CREDIT_REQUEST_FORM_PADDING}>
        <Select
          label={t('input.expenseType.label')}
          data={options['expenseType'].map(el => (
            { value: el, label: t(`input.expenseType.options.${el}`) }
          ))}
          key={expenseForm.key(`${index}.expenseType`)}
          {...expenseForm.getInputProps(`${index}.expenseType`)}
          clearable={true}
          disabled={disabled}
        />
        <NumberInput
          label={t('input.amount.label')}
          key={expenseForm.key(`${index}.amount`)}
          {...expenseForm.getInputProps(`${index}.amount`)}
          min={0}
          rightSection={<Text size={'sm'} >{t('currency.switzerland')}</Text>}
          rightSectionWidth={40}
          disabled={disabled}
          {...DECIMAL_PROPS}
        />
        {!disabled ?
          <Box mb={6}>
            <InputLabel label={t('action.addExpense')} />
            <Group>
              <Radio color={'#75AD53'} checked={additionalExpense} onChange={() => changeAdditionalExpense(true)} label={t('input.radio.true')} disabled={disabled} />
              <Radio color={'#75AD53'} checked={!additionalExpense} onChange={() => changeAdditionalExpense(false)} label={t('input.radio.false')} disabled={disabled} />
            </Group>
          </Box>
        : undefined}
      </Stack>
  </Box>
  )
}

export default CreditRequestExpensesItem;